/* eslint-disable no-undef */
import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { userDetail } from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import { logout } from 'Utils/commonApi';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as AccountIcon } from 'Assets/svg/account-outline.svg';
import { ReactComponent as ContactEmailIcon } from 'Assets/svg/contact-email.svg';
import { ReactComponent as ViewsIcon } from 'Assets/svg/views-eye.svg';
import { ReactComponent as DownloadsIcon } from 'Assets/svg/downloads-down.svg';
import { ReactComponent as SuppressionListIcon } from 'Assets/svg/suppression-list.svg';
import { ReactComponent as LogoutIcon } from 'Assets/svg/logout.svg';
import { ReactComponent as AdminHomeIcon } from 'Assets/svg/admin-home.svg';
import { ReactComponent as DataOperationsIcon } from 'Assets/svg/data-operations.svg';
import { ReactComponent as QualifyUsersIcon } from 'Assets/svg/qualify-user.svg';
import { ReactComponent as ManageCustomersIcon } from 'Assets/svg/manage-customers.svg';
import { ReactComponent as ManageTeamIcon } from 'Assets/svg/manage-team.svg';
import { ReactComponent as CustomPlanManagementIcon } from 'Assets/svg/customer-plan-management.svg';

const AccountProfileWrapper = observer(props => {
  const { userInfo, featureFlags, hasCustomPlanManage = false } = userDetail;
  const {
    email = '',
    name = '',
    views,
    downloads,
    role = 'ROLE_MEMBER',
    isEnterpriseAdmin = false,
    noOfSeatsEligible = 1,
  } = userInfo;
  const { LEAD_BUILDER = false } = featureFlags;
  const [showDropdown, setShowDropdown] = React.useState(false);
  const showDropdownMenu = () => {
    setShowDropdown(true);
  };

  const hideDropdownMenu = (e, val = null) => {
    setShowDropdown(false);
  };

  const handleLogout = () => {
    logout();
  };

  const handleRedirect = (e, url) => {
    window.location.href = CONSTANTS.WEB_URL + url;
  };

  const redirectToNewAdmin = (e, url) => {
    window.location.href = CONSTANTS.NEW_ADMIN_URL + url;
  };
  return (
    <div
      className="account-profile release-note"
      onMouseEnter={showDropdownMenu}
      onMouseLeave={e => hideDropdownMenu(e)}
    >
      <div className="account-icon-wrap">
        {Utils.getUserName().substring(0, 1)}
      </div>
      <div className={`user-dropdown${showDropdown ? '' : ' hide'}`}>
        <span className="sharp-point" />
        <div className="profile-link-list">
          <div className="profile-list-item email-wrap">
            <div className="icon-wrapper">
              <ContactEmailIcon />
            </div>
            <div className="text-wrapper">{email}</div>
          </div>
          {LEAD_BUILDER && !Utils.isCreditBasedSubscription() && (
            <>
              <div className="seperate-border" />
              <div className="profile-list-item">
                <div className="icon-wrapper">
                  <ViewsIcon />
                </div>
                <div className="text-wrapper">
                  {Utils.viewsDownloadsNumberFormat(views)} Views
                </div>
              </div>
              <div className="profile-list-item">
                <div className="icon-wrapper">
                  <DownloadsIcon />
                </div>
                <div className="text-wrapper">
                  {Utils.viewsDownloadsNumberFormat(downloads)} Downloads
                </div>
              </div>
            </>
          )}
          <div className="seperate-border" />
          {Utils.isInternalAdminUser() && (
            <>
              <div className="profile-list-item">
                <div className="icon-wrapper">
                  <AdminHomeIcon />
                </div>
                <div
                  className="text-wrapper"
                  onClick={e => redirectToNewAdmin(e, '')}
                >
                  New Admin Home
                </div>
              </div>
              <div className="profile-list-item">
                <div className="icon-wrapper">
                  <AdminHomeIcon />
                </div>
                <div
                  className="text-wrapper"
                  onClick={e => handleRedirect(e, '/adm/listCSVVerify.htm')}
                >
                  Admin Home
                </div>
              </div>
              <div className="profile-list-item">
                <div className="icon-wrapper">
                  <QualifyUsersIcon />
                </div>
                <div
                  className="text-wrapper"
                  onClick={e => handleRedirect(e, '/adm/qualifyUsers.htm')}
                >
                  Qualify User
                </div>
              </div>
              <div className="profile-list-item">
                <div className="icon-wrapper">
                  <ManageCustomersIcon />
                </div>
                <div
                  className="text-wrapper"
                  onClick={e => handleRedirect(e, '/adm/manageCustomers.htm')}
                >
                  Manage Customers
                </div>
              </div>
            </>
          )}
          {role === 'ROLE_DATA_ADMIN' && (
            <div className="profile-list-item">
              <div className="icon-wrapper">
                <DataOperationsIcon />
              </div>
              <div
                className="text-wrapper"
                onClick={e => redirectToNewAdmin(e, '/data-operations')}
              >
                Ops Task System
              </div>
            </div>
          )}
          {isEnterpriseAdmin &&
            noOfSeatsEligible > 1 &&
            !Utils.isCreditBasedSubscription() && (
              <div className="profile-list-item">
                <div className="icon-wrapper">
                  <ManageTeamIcon />
                </div>
                <Link to="/manage-team" className="text-wrapper">
                  Manage Team
                </Link>
              </div>
            )}
          {Utils.isInternalAdminUser() && hasCustomPlanManage && (
            <div className="profile-list-item">
              <div className="icon-wrapper">
                <CustomPlanManagementIcon />
              </div>
              <div
                className="text-wrapper custom-plan"
                onClick={e => handleRedirect(e, '/adm/customPlanManage.htm')}
              >
                Custom Plan Management
              </div>
            </div>
          )}
          <div className="profile-list-item">
            <div className="icon-wrapper">
              <SuppressionListIcon />
            </div>
            <Link to="/suppression-list" className="text-wrapper">
              Suppression Lists
            </Link>
          </div>
          <div className="profile-list-item">
            <div className="icon-wrapper">
              <AccountIcon className="account-icon" />
            </div>
            <Link to="/profile/settings" className="text-wrapper">
              Account & Billing
            </Link>
          </div>

          <div className="profile-list-item" onClick={handleLogout}>
            <div className="icon-wrapper">
              <LogoutIcon />
            </div>
            <div className="text-wrapper">Log Out</div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default AccountProfileWrapper;
export { AccountProfileWrapper };
